import { Button } from "@/shared/ui/button";
import { useIsDemoUser } from "@/shared/hooks/useIsDemoUser";
import { Cog, Menu } from "lucide-react";
import { useState } from "react";
import { SignupModal } from "./SignupModal";
import { LoginModal } from "./LoginModal";

export function LandingHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSignupOpen, setIsSignupOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const isDemoUser = useIsDemoUser();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="bg-gradient-primary rounded-lg p-2">
              <Cog className="h-6 w-6 text-primary-foreground" />
            </div>
            <div>
              <span className="text-lg font-bold text-foreground tracking-wide">ROBOTIC IMAGING</span>
              <div className="text-xs text-primary font-medium">ASSET MANAGEMENT</div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a href="#features" className="text-muted-foreground hover:text-primary transition-colors font-medium">
              Solutions
            </a>
            <a href="#pricing" className="text-muted-foreground hover:text-primary transition-colors font-medium">
              Pricing
            </a>
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-4">
            {isDemoUser && (
              <Button variant="default" asChild>
                <a href="https://www.roboticimaging.com/contact" target="_blank" rel="noopener noreferrer">
                  Contact Sales
                </a>
              </Button>
            )}
            <Button 
              variant="ghost" 
              className="text-muted-foreground hover:text-primary"
              onClick={() => setIsLoginOpen(true)}
            >
              Sign In
            </Button>
            <Button variant="default" onClick={() => setIsSignupOpen(true)}>Get Started</Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <Menu className="h-6 w-6 text-foreground" />
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-border bg-background/98 backdrop-blur-md">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <a href="#features" className="block px-3 py-2 text-muted-foreground hover:text-primary">
                Solutions
              </a>
              <a href="#pricing" className="block px-3 py-2 text-muted-foreground hover:text-primary">
                Pricing
              </a>
              <div className="px-3 py-2 space-y-2">
                {isDemoUser && (
                  <Button variant="default" className="w-full" asChild>
                    <a href="https://www.roboticimaging.com/contact" target="_blank" rel="noopener noreferrer">
                      Contact Sales
                    </a>
                  </Button>
                )}
                <Button 
                  variant="ghost" 
                  className="w-full"
                  onClick={() => setIsLoginOpen(true)}
                >
                  Sign In
                </Button>
                <Button variant="default" className="w-full" onClick={() => setIsSignupOpen(true)}>Get Started</Button>
              </div>
            </div>
          </div>
        )}
      </div>
      
      <SignupModal isOpen={isSignupOpen} onClose={() => setIsSignupOpen(false)} />
      <LoginModal isOpen={isLoginOpen} onClose={() => setIsLoginOpen(false)} />
    </header>
  );
}